import axios from "axios";

export default axios.create({
  baseURL: "https://deploy-app-dindin.onrender.com",
  timeout: 10000,
});
